/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UserRestService } from '@gh/builder-shared-data';
import { InitDialogViewService, UserContext } from '@gh/common-shared';
import { DialogRouteSnapshot, S3UploadItem } from '@gh/core-ui';
import { Observable } from 'rxjs';
import { UserProfileSignatureDialogConfig } from '../../user-profile-signature';

export type UserProfilePhoto = { picture: S3UploadItem };

export type UserProfilePhotoDialogConfig = Record<string, never>;

@Injectable()
export class UserProfilePhotoBusinessService implements InitDialogViewService<UserProfilePhotoDialogConfig> {
  constructor(
    private userContext: UserContext,
    private userRest: UserRestService,
  ) {
  }

  initDialogView(route: DialogRouteSnapshot<UserProfileSignatureDialogConfig>): any {
    return {
      photo: this.getPhoto(),
    };
  }

  getPhoto(): Observable<S3UploadItem> {
    return this.userRest.getPhoto(this.userContext.data.id);
  }

  savePhoto(photo: S3UploadItem, croppedArea: any, cropperCoords: any): Observable<any> {
    return this.userRest.savePhoto(this.userContext.data.id,  photo, croppedArea, cropperCoords);
  }
}
